// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';

/**
 * Global app footer. Sits at the bottom of the shell (below the scrollable main
 * area) on every page, giving content bottom clearance and a persistent
 * copyright line.
 */
export default function HeliosFooter() {
  return (
    <footer className="helios-footer">
      <span>© 2026 Helios. All rights reserved.</span>
    </footer>
  );
}
